import { ResetPasswordPage } from "@/features/auth/pages/ResetPasswordPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/auth/reset-password/$token")({
	component: function VendorResetPasswordRoute() {
		const { token } = Route.useParams();
		return <ResetPasswordPage token={token} successRoute="/vendor/login" />;
	},
});
